<!-- !! Attention: Student account會共用呢個page，留意返啲permission !! -->
<template>
  <v-container fluid>
    <PageHeaderSlot showBackButton>
      <template slot="top-right-slot" v-if="canEdit">
        <FormButton text="editPoints" @click="handleEditPoints()" class="ml-2" />
      </template>
    </PageHeaderSlot>

    <Datatable
      class="mb-8"
      tableName="menu.pointsRecord"
      :isLoading="recordFilter.loading"
      :tableHeaders="recordTableHeaders"
      :tableData="recordFilter.tableData"
      :page.sync="recordFilter.page"
      :pageLimit.sync="recordFilter.limit"
      :itemTotal="recordFilter.total"
      @options-update="getPointsRecord()"
    />
    <Datatable
      tableName="pointsWithinDays"
      :isLoading="canUseFilter.loading"
      :tableHeaders="canUseTableHeaders"
      :tableData="canUseFilter.tableData"
      disablePagination
    />

    <!-- Modal: 新增/扣減積分 -->
    <FormDialog title="editPoints" ref="editPointsFormDialog" formRef="editPointsForm" :maxWidth="600">
      <v-row class="ma-0">
        <v-col cols="12" sm="6">
          <FormSelect
            label="addOrDeduct"
            :fieldValue.sync="editPointsData.type"
            :options="editPointsTypeOptions"
            required
          />
        </v-col>
        <v-col cols="12" sm="6">
          <FormInput type="number" label="pointsName" :fieldValue.sync="editPointsData.points" isIntegerOnly required />
        </v-col>
        <v-col cols="12" sm="6">
          <FormInput label="remark" :fieldValue.sync="editPointsData.remark" />
        </v-col>
      </v-row>
    </FormDialog>
  </v-container>
</template>

<script>
import Datatable from '@/components/Datatable.vue'
import FormSelect from '@/components/formField/FormSelect.vue'
import FormInput from '@/components/formField/FormInput.vue'
import FormDialog from '@/components/FormDialog.vue'

export default {
  name: 'StudentPoints',
  components: {
    Datatable,
    FormSelect,
    FormInput,
    FormDialog,
  },
  computed: {
    // permission & setting
    canEdit() {
      return this.$validate.allowAction('editStudentPoints', this.userType)
    },
  },
  data: vm => ({
    userType: vm.gfGetUserType(),
    id: null,

    recordFilter: {
      page: 1,
      limit: 10,
      total: 0,
      tableData: [],
      loading: false,
    },

    canUseFilter: {
      tableData: [],
      loading: false,
    },

    editPointsData: {
      type: '',
      points: '',
      remark: '',
    },

    recordTableHeaders: [
      { value: 'create_date', text: vm.$t('createdDate'), width: 130 },
      { value: 'reason', text: vm.$t('reason'), width: 250 },
      { value: 'amount', text: vm.$t('pointsAmount'), width: 150 },
      { value: 'remark', text: vm.$t('remark') },
    ],
    canUseTableHeaders: [
      { value: 'expired_date', text: vm.$t('expiredDate'), width: 130 },
      { value: 'points', text: vm.$t('pointsName') },
    ],
    editPointsTypeOptions: [
      { value: 'add', text: vm.$t('addPoints') },
      { value: 'deduct', text: vm.$t('deduct') },
    ],
  }),
  methods: {
    // ===== 積分紀錄 =====
    async getPointsRecord() {
      this.recordFilter.loading = true
      try {
        let payload = {
          filter_limit: this.recordFilter.limit,
          filter_page: this.recordFilter.page - 1,
        }

        const { data, total } = await this.$Fetcher.GetUserPointsRecords(this.id, payload)
        this.recordFilter.total = total
        this.recordFilter.tableData = []
        await this._mapRecordData(data)
      } catch (err) {
        this.$common.error(err)
        this.recordFilter.tableData = []
        if (this.recordFilter.page === 1) {
          this.recordFilter.total = 0
        }
        this.recordFilter.loading = false
        if (err === 'abort') {
          return false
        }
      }

      this.recordFilter.loading = false
      return true
    },
    async _mapRecordData(list, count = 0) {
      if (count < list.length) {
        const obj = {
          id: count,
          create_date: list[count].create_date,
          reason: this.$t(`pointsUseTypes.${list[count].type}`),
          amount: list[count].points > 0 ? `+${list[count].points}` : list[count].points,
          remark: list[count].remark,
        }

        if (this.$validate.DataValid(list[count].order_id) && list[count].order_id > -1) {
          const orderCode = await this.gfGenerateOrderId({ id: list[count].order_id })
          if (orderCode !== 'abort') {
            obj['reason'] += ` (${orderCode})`
          }
        }

        this.recordFilter.tableData.push(obj)
        count += 1
        await this._mapRecordData(list, count)
      }
    },

    // ===== 60日內過期積分 =====
    async getPointsCanUseRecord() {
      this.canUseFilter.loading = true
      try {
        const data = await this.$Fetcher.GetUserPointsRecordWithinDays(this.id)
        this.canUseFilter.tableData = data.map(item => {
          return {
            id: item.id,
            expired_date: item.expiry_date ? item.expiry_date.substring(0, 10) : '',
            points: item.value || 0,
          }
        })
      } catch (err) {
        this.$common.error(err)
        this.canUseFilter.tableData = []
      } finally {
        this.canUseFilter.loading = false
      }
    },

    // ===== 新增/扣減積分 =====
    async handleEditPoints(newOpen = true) {
      // reset form when open
      if (newOpen) {
        if (this.$store.getters.isLoading) {
          this.$store.dispatch('toggleSnack', { message: 'processing' })
          return
        }
        this.editPointsData.type = ''
        this.editPointsData.points = ''
        this.editPointsData.remark = ''
        await this.$refs.editPointsFormDialog.resetForm()
      } else {
        this.$refs.editPointsFormDialog.setLoading(false)
      }

      // handle form submit
      const confirm = await this.$refs.editPointsFormDialog.show()
      if (confirm) {
        const vm = this
        try {
          const getStaff = this.gfGetCurrentUserData()
          const payload = {
            value: parseInt(this.editPointsData.points),
            staff_id: getStaff.id,
            remark: this.editPointsData.remark,
          }

          if (this.editPointsData.type === 'add') {
            await this.$Fetcher.AddPoints(this.id, payload)
          } else if (this.editPointsData.type === 'deduct') {
            await this.$Fetcher.DeductPoints(this.id, payload)
          }
          setTimeout(() => {
            vm.$store.dispatch('toggleSnack', {
              message: 'message.updateSuccess',
              type: 'success',
            })
            vm.$refs.editPointsFormDialog.hide()
            vm.recordFilter.page = 1
            vm.getPointsRecord()
            vm.getPointsCanUseRecord()
          }, 500)
        } catch (err) {
          this.$common.error(err)
          this.showAlert({
            title: 'message.updateFail',
            message: err,
            isError: true,
          })
          this.handleEditPoints(false)
        }
      }
    },

    async handleSiteLoaded() {
      this.$common.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>> handleSiteLoaded: StudentPoints')
      this.userType = this.gfGetUserType()

      const id = parseInt(this.$route.params.id)
      if (!isNaN(id)) this.id = id
      if (this.userType === 'student') {
        const userData = this.gfGetCurrentUserData()
        this.id = userData.id
      }
      this.$store.dispatch('toggleLoadingPage', false)

      if (this.$validate.DataValid(this.id)) {
        this.recordFilter.loading = true
        this.canUseFilter.loading = true
        let next = await this.getPointsRecord()
        if (next) {
          this.getPointsCanUseRecord()
        }
      }
    },
  },
  destroyed() {
    window.removeEventListener('onSiteLoaded', this.handleSiteLoaded)
  },
  mounted() {
    this.$store.dispatch('toggleLoadingPage', true)
    window.addEventListener('onSiteLoaded', this.handleSiteLoaded)
  },
  // ------ navigation guard ------
  beforeRouteLeave(to, from, next) {
    this.$XHR.abort()
    next()
  },
}
</script>
